<template>
	<div class="wy-advanced-sentiment-trend-graph" v-loading="loading">
		<div ref="cssChart" class="css-chart">
			<div class="div-negative"></div>
			<div class="div-neutral"></div>
			<div class="div-positive"></div>
			<ul id="line-chart" class="line-chart"></ul>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import WyConstants from "../../library/wy-constants";

export default {
	name: "wy-advanced-sentiment-trend-graph",

	data() {
		return {
			loading: false,
			sentByMap: {
				A: "Agent",
				U: "Customer",
			},
			sentimentMap: {
				Negative: -1,
				Neutral: 0,
				Positive: 1,
			},
			chartData: {
				duration: 0,
				agentChannel: [],
				customerChannel: [],
			},
		};
	},

	methods: {
		...mapActions(["fetchSentimentTrendGraph", "postIFrameEvent"]),

		createListItemCustomer(item, color) {
			return `
        <div data-testid="App-Recordings-MediaPlayer-AISentiment-Customer" class="data-point blue" data-value="${item.value}"></div>
        <div class="line-segment ${color}" style="--hypotenuse: ${
				item.hypotenuse
			}; --angle:${item.angle};"></div>
      `;
		},
		createListItemAgent(item, color) {
			return `
        <div data-testid="App-Recordings-MediaPlayer-AISentiment-Agent" class="data-point red" data-value="${item.value}"></div>
        <div class="line-segment ${color}" style="--hypotenuse: ${
				item.hypotenuse
			}; --angle:${item.angle};"></div>
      `;
		},
		createListItem(item, color) {
			if (item.sentBy === "Agent") {
				return this.createListItemAgent(item, color);
			} else {
				return this.createListItemCustomer(item, color);
			}
		},
		render(data, container, color) {
			data.forEach((item) => {
				const markup = this.createListItem(item, color);
				const listItem = document.createElement("li");

				listItem.style.cssText = `--x: ${item.left +
					100}px; --y: ${item.bottom - 50}px`;
				listItem.innerHTML = markup;
				listItem.querySelector(".data-point").addEventListener(
					"click",
					(e) => {
						this.pointClick(e, item);
					},
					true
				);
				listItem.querySelector(".data-point").addEventListener(
					"mouseover",
					(e) => {
						this.mouseover(e, item);
					},
					true
				);
				listItem
					.querySelector(".data-point")
					.addEventListener("mouseout", () => {
						this.mouseout();
					});
				container.appendChild(listItem);
			});
		},
		formatLineChartData(duration, values, chartHeight) {
			if (document.querySelector(".css-chart")) {
				let base = 0;
				const bodyHeight = document
					.querySelector(".css-chart")
					.getBoundingClientRect().height;
				const bodyWidth = document
					.querySelector(".css-chart")
					.getBoundingClientRect().width;

				const rateHeight = bodyHeight / duration; //(bodyHeight - 300) / 250;
				const rateWidth = 0.365;
				const widgetSize = chartHeight;
				const pointSize = rateWidth * bodyWidth;
				const originalData = [...values];
				values.forEach((element) => {
					element.x = element.time * rateHeight;
				});
				//const sortedValues = this.sortValues([...values]);
				const topMostPoint = 1; //sortedValues[0].value;
				let nextPoint = 0;
				let rise = 0;
				const cssValues = [];

				for (let i = 0, len = values.length - 1; i < len; i++) {
					const currentValue = {
						index: i,
						left: 0,
						bottom: 0,
						hypotenuse: 0,
						angle: 0,
						value: 0,
						time: 0,
						sentBy: originalData[i].sentBy,
						messageSeq: originalData[i].messageSeq,
					};

					currentValue.value = values[i].value;
					currentValue.left = values[i].x;
					if (i == values.length - 1) {
						base = values[i].x;
					} else {
						base = values[i + 1].x - values[i].x;
					}
					currentValue.bottom =
						(widgetSize - pointSize) *
						(currentValue.value / topMostPoint);
					nextPoint =
						(widgetSize - pointSize) *
						(values[i + 1].value / topMostPoint);
					rise = currentValue.bottom - nextPoint;
					currentValue.hypotenuse = Math.sqrt(
						base * base + rise * rise
					);
					currentValue.angle =
						this.radiansToDegrees(
							Math.asin(rise / currentValue.hypotenuse)
						) + 90;
					currentValue.time = originalData[i].time;
					const left = currentValue.left;
					const bottom = currentValue.bottom;
					currentValue.left = bottom - (100 - bodyWidth / 2);
					currentValue.bottom = 0 - left;
					cssValues.push(currentValue);
				}

				const lastPoint = {
					index: values.length - 1,
					left:
						(widgetSize - pointSize) *
							(values[values.length - 1].value / topMostPoint) -
						(100 - bodyWidth / 2),
					bottom: 0 - values[values.length - 1].x,
					hypotenuse: 0,
					angle: 0,
					value: values[values.length - 1].value,
					time: originalData[values.length - 1].time,
					sentBy: originalData[values.length - 1].sentBy,
					messageSeq: originalData[values.length - 1].messageSeq,
					lastPoint: true,
				};
				cssValues.push(lastPoint);
				return cssValues;
			}
		},

		radiansToDegrees(rads) {
			return rads * (180 / Math.PI);
		},
		sortValues(values) {
			return values.sort((a, b) => b.value - a.value);
		},
		async drawChart() {
			const element = document.getElementById("line-chart");
			while (element.firstChild) {
				element.removeChild(element.firstChild);
			}

			if (this.chartData.duration > 0) {
				if (this.chartData.agentChannel.length > 0) {
					this.render(
						this.formatLineChartData(
							this.chartData.duration,
							this.chartData.agentChannel,
							2
						),
						document.getElementById("line-chart"),
						"red"
					);
				}
				if (this.chartData.customerChannel.length > 0) {
					this.render(
						this.formatLineChartData(
							this.chartData.duration,
							this.chartData.customerChannel,
							2
						),
						document.getElementById("line-chart"),
						"blue"
					);
				}
			}
		},
		pointClick(e, item) {
			this.postIFrameEvent({
				channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER,
				action: "AdvSentiment.Transcription.setMessageTime",
				index: item.messageSeq - 1,
				time: item.time,
			});
		},
		mouseover(e, item) {
			const tooltipsEl = document.querySelector(".site-tooltips");
			if (tooltipsEl) {
				tooltipsEl.innerHTML = item.sentBy;
				tooltipsEl.style.display = "block";
				const adjust = 0;
				tooltipsEl.style.left = `${e.target.getBoundingClientRect()
					.left -
					tooltipsEl.getBoundingClientRect().width / 2 +
					2 +
					adjust}px`;
				if (item.lastPoint) {
					tooltipsEl.style.top = `${e.target.getBoundingClientRect()
						.top - 20}px`;
				} else {
					tooltipsEl.style.top = `${e.target.getBoundingClientRect()
						.top + 15}px`;
				}
			}
		},
		mouseout() {
			const tooltipsEl = document.querySelector(".site-tooltips");
			if (tooltipsEl) {
				tooltipsEl.style.display = "none";
			}
		},
	},

	mounted() {
		window.addEventListener("resize", () => {
			this.drawChart();
		});
	},

	async created() {
		try {
			const conversationId = this.$route.query.contactId;
			const callDuration = this.$route.query.callDuration;
			this.loading = true;
			const res = await this.fetchSentimentTrendGraph({ conversationId });
			this.loading = false;

			if (res.data && res.data.messages && res.data.messages.length > 0) {
				this.chartData = {
					duration: callDuration, //res.data.duration,
					agentChannel: [],
					customerChannel: [],
				};

				const messageList = res.data.messages;
				messageList.forEach((message) => {
					if (message.sentBy === "A") {
						this.chartData.agentChannel.push({
							sentBy: "Agent",
							value: this.sentimentMap[message.sentiment],
							time: message.beginTimeMs,
							messageSeq: message.messageSeq,
						});
					} else {
						this.chartData.customerChannel.push({
							sentBy: "Customer",
							value: this.sentimentMap[message.sentiment],
							time: message.beginTimeMs,
							messageSeq: message.messageSeq,
						});
					}
				});
				this.drawChart(this.chartData);
			} else {
				this.postIFrameEvent({
					channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER,
					action: "AdvSentiment.trendGraph.enable",
					hasData: false,
				});
			}
		} finally {
			this.loading = false;
		}
	},
};
</script>

<style lang="scss">
.wy-advanced-sentiment-trend-graph {
	width: 100%;
	height: 100%;
	overflow-y: hidden;
	text-align: left;

	.css-chart-header {
		border-bottom: 0px solid;
		border-left: 0px solid;
		display: inline-block;
		position: relative;
		display: inline-flex;
		width: var(--widget-size);
		margin: 0px 10px;
		width: calc(100% - 20px) !important;
		height: 30px !important;
		position: absolute;
		top: -8px;
		left: 0px;
		flex-direction: row-reverse;
		align-items: flex-start;
		.div-positive-header {
			background-image: url("../../assets/brands/as/icons/icon_as_trend_emoji_good.svg");
			background-repeat: no-repeat;
			background-position: top;
			background-position-y: 11px;
			background-position-x: center;
			width: 33.33%;
			height: 100%;
			position: relative;
			margin: 0px calc(6%) 0px calc(3% + 1px) !important;
		}
		.div-neutral-header {
			background-image: url("../../assets/brands/as/icons/icon_as_trend_emoji_neutral.svg");
			background-repeat: no-repeat;
			background-position: top;
			background-position-y: 11px;
			width: 33.33%;
			height: 100%;
			position: relative;
			margin: 0px 5% 0px 8% !important;
		}
		.div-negative-header {
			background-image: url("../../assets/brands/as/icons/icon_as_trend_emoji_bad.svg");
			background-repeat: no-repeat;
			background-position: top;
			background-position-y: 11px;
			background-position-x: center;
			width: 33.33%;
			height: 100%;
			position: relative;
			margin: 0px 4% 0px 8% !important;
		}
	}

	.css-chart {
		border-bottom: 0px solid;
		border-left: 0px solid;
		display: inline-block;
		position: relative;
		display: inline-flex;
		width: var(--widget-size);
		margin: 0px 10px;
		width: calc(100% - 20px) !important;
		height: calc(100% - 14px) !important;
		left: 0px;
		top: -8px;
		flex-direction: row-reverse;
		align-items: flex-start;
	}
	.div-positive {
		background-image: url("../../assets/brands/as/icons/icon_as_trend_emoji_good.svg");
		background-repeat: no-repeat;
		background-position: top;
		background-position-y: 0px !important;
		background-color: #a8d19b;
		opacity: 0.6;
		width: 33.33%;
		height: 100%;
		position: relative;
		margin: 0px calc(6%) 0px calc(3% + 1px) !important;
	}
	.div-neutral {
		background-image: url("../../assets/brands/as/icons/icon_as_trend_emoji_neutral.svg");
		background-repeat: no-repeat;
		background-position: top;
		background-color: #fbdba7;
		background-position-y: 0px !important;
		opacity: 0.6;
		width: 33.33%;
		height: 100%;
		position: relative;
		margin: 0px 5% 0px 8% !important;
	}
	.div-negative {
		background-image: url("../../assets/brands/as/icons/icon_as_trend_emoji_bad.svg");
		background-repeat: no-repeat;
		background-position: top;
		background-position-y: 0px !important;
		background-color: #ebaead;
		width: 33.33%;
		opacity: 0.6;
		height: 100%;
		position: relative;
		margin: 0px 4% 0px 8% !important;
	}
	.line-chart {
		list-style: none;
		margin: 0;
		padding: 0;
		position: relative;
		display: block;

		.data-point {
			background-color: white;
			border: 2px solid lightblue;
			border-radius: 50%;
			bottom: calc(var(--y) + 46px);
			height: 5px;
			left: calc(var(--x) - 3px);
			position: absolute;
			width: 5px;
			z-index: 1;
			cursor: pointer;
		}
		.data-point.blue {
			border: 2px solid #0277be;
		}
		.data-point.red {
			border: 2px solid #d42f2f;
		}

		.line-segment {
			background-color: #0277be;
			bottom: calc(var(--y) + 50px);
			height: 3px;
			left: var(--x);
			position: absolute;
			transform: rotate(calc(var(--angle) * 1deg));
			transform-origin: left bottom;
			width: calc(var(--hypotenuse) * 1px);
		}

		.line-segment.green {
			background-color: #0277be !important;
		}

		.line-segment.red {
			background-color: #d42f2f !important;
		}
	}
	#app.wy-brand.wy-product-as.wy-advSentimentTrendGraph-page {
		.site-tooltips {
			font-size: 9px !important;
			padding: 2px 3px !important;
		}
	}
}
</style>
